const React = require('react');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const SharedConstants = require('../../../../../shared/sharedConstants');
const CardModal = require('../../components/cardModal.jsx').CardModal;
const ToastAlert = require('../../components/toastAlert');
const shortid = require('shortid');

import * as AjaxFunctions from '../../ajaxFunctions';
import ReduxStore from '../../redux/reduxStore.jsx.js';

import {
   Tab,
   Tabs,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MPubCardSimple, MPubCardLink } from '../../components/mPubCard';
import MPubSearch from '../../components/mPubSearch';

class ManiaListViewBase extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         isLoadingData: false,
         prevScrollTop: 0,
         closeModal: false,
         deckList: [],
         tab: 0,
      }
   }

   async loadMoreCards() {
      let lastDate = null;
      let list = this.props.filteredCardList;
      if (list.length > 0) {
         lastDate = list[list.length - 1].creationTime;
      }
      try {
         await this.props.lastFilterFunction(lastDate, true)
      } catch(e) {
         console.log(e);
      }
   }

   async getAllCardData() {
      this.setState({ isLoadingData: true });
      let unapprovedCards = await AjaxFunctions.getUnapprovedCards();
      ReduxStore.store.dispatch(ReduxStore.CardFunctions.setUnapproved(unapprovedCards));
      await this.loadMoreCards();
      this.setState({ isLoadingData: false });
   }

   async getDecks() {
      let deckList = await AjaxFunctions.getDecks();
      this.setState({ deckList });
   }

   getInitialData() {
      Promise.all([
         AjaxFunctions.getDecks(),
         AjaxFunctions.getCardsToReview()
      ]).then( ([deckList, cardsToReview] ) => {
         this.setState({ deckList });
         ReduxStore.store.dispatch(ReduxStore.CardFunctions.setToReview(cardsToReview));
         ReduxStore.store.dispatch(ReduxStore.DeckFunctions.setDeckList(deckList));
      })
   }

   componentDidMount() {
      let container = document.getElementById('maniaCreateConjectureDialogContent');
      container.onscroll = async () => {
         // Calculate percentage of page scrolled
         let { scrollTop, scrollHeight, clientHeight} = container;
         let scrollPercent = scrollTop / (scrollHeight - clientHeight);
         if(
            !this.state.isLoadingData
            && scrollPercent >= 0.75
            && this.state.tab !== Tabs.Workspace
         ) {
            this.getAllCardData();
         }
      };

      this.getInitialData();
      this.getAllCardData();
   }

   componentDidUpdate(prevProps) {
      if (prevProps.location && this.props.location) {
         const lastState = prevProps.location.state || {};
         const currState = this.props.location.state || {};
         if (lastState.refresh != currState.refresh) {
            this.getInitialData();
            this.getAllCardData();
         }
      }
   }

   componentWillUnmount() {
      let container = document.body;
      container.onscroll = () => {};
   }

   search(searchString, advSearch) {
      this.props.lastFilterFunction();
      /*
      let filterData = {
         searchString,
         cardTypes: [],
         topics: [],
      };

      advSearch.forEach(filter => {
         if (filter.name == 'Evidence') {
            filterData.cardTypes.push(SharedConstants.CardType.Evidence);
         } else if (filter.name == 'Conjecture') {
            filterData.cardTypes.push(SharedConstants.CardType.Reasoning);
         } else {
            filterData.topics.push(filter.idTopic);
         }
      });

      const hasFilterData = searchString
         || filterData.cardTypes.length > 0
         || filterData.topics.length > 0;
      if (hasFilterData) {
         AjaxFunctions.getFilteredCardData(filterData)
            .then(data => ReduxStore.processCardData(data))
            .catch(err => ToastAlert.error(err));
      } else {
         this.props.lastFilterFunction();
      }

       */
   }


   render() {
      let overrideFilteredCardList = this.props.filteredCardList;
      if(this.props.evidenceToLink.length === 0 && this.props.overrideFilteredCardList){
         overrideFilteredCardList = this.props.overrideFilteredCardList;
      }

      let commonProps = {
         cardLinkFunction: (cardData) => this.props.cardLinkFunction(cardData),
         showLinkBtn: this.props.showLinkBtn,
         portfolios: this.props.portfolios,
         incubators: this.props.incubators,
      };

      let tabView = this.state.tab ? (
         <FavoritesTab
            tagList={this.props.tagList}
            setWorkspaceFilterListFunction={this.props.setWorkspaceFilterListFunction}
            tagFilterList={this.props.tagFilterList}
            deckList={this.state.deckList}
            {...commonProps}
         />
      ) : (
         <AllTab
            conjectureGameCards={this.props.conjectureGameCards}
            unapprovedCards={this.props.unapprovedCards}
            filteredCardList={overrideFilteredCardList}
            recentCards={this.props.recentCards}
            cardsToReview={this.props.cardsToReview}
            isCreatingConjecture={this.props.isCreatingConjecture}
            {...commonProps}
         />
      );

      return (
         <div id='listViewMainContainer'>
            <MPubSearch
               search={(...args) => this.search(...args)}
               initialAdvSearch={[{"group": "Card Type", "name": "Evidence"}]}
            />
            <Tabs
               className='userview-tabs'
               value={this.state.tab}
               onChange={(event, tab) => this.setState({ tab })}
               indicatorColor="primary"
               textColor="primary"
               style={{ margin: '15px 0' }}
            >
               <Tab className='portfolio-list-page-tab-header material-button' label='All' />
               <Tab className='portfolio-list-page-tab-header material-button' label='Favorites' />
            </Tabs>
            {tabView}
            <CardModal returnUrl={window.location.pathname} />
         </div>
      );
   }
}

const mapListViewStateToProps = (state) => {
   let filteredCardList = state.CardReducer.cardList;
   return {
      evidenceToLink: state.GreySpaceCardReducer.creationEvidence,
      unapprovedCards: state.CardReducer.unapprovedList,
      conjectureGameCards: state.CardReducer.conjectureGameList,
      filteredCardList,
      recentCards: state.EvidenceCardReducer.recentCards,
      showLinkBtn: state.EditorReducer.showLinkBtn,
      tagList: state.WorkspaceTagReducer.tagList,
      tagFilterList: state.WorkspaceTagReducer.filterList,
      portfolios: state.PortfolioReducer.portfolioList.owned,
      incubators: state.PortfolioReducer.portfolioList.sponsored,
      cardsToReview: state.CardReducer.toReview,
   }
};

const mapListViewDispatchToProps = (dispatch) => {
   return {
      cardLinkFunction: (cardData) => {
         if(cardData.cardType === SharedConstants.CardType.Evidence) {
            dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(cardData));
         }
         else if(cardData.cardType === SharedConstants.CardType.Reasoning)
            dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(cardData));

      },
      setWorkspaceFilterListFunction: (filterList) => {
         dispatch(ReduxStore.WorkspaceTagFunctions.setFilterList(filterList))
      }
   }
};

export default connect(
   mapListViewStateToProps,
   mapListViewDispatchToProps
)(ManiaListViewBase);

class FavoritesTab extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showUntagged: false,
         isExpanded: true,
      }
   }

   onTagClicked(tag) {
      let selectedTagList = this.props.tagFilterList.slice();
      let tagExists = false;
      for(let i = 0; i < selectedTagList.length; i++){
         if(selectedTagList[i] === tag){
            selectedTagList.splice(i,1);
            tagExists = true;
            break;
         }
      }
      if(!tagExists){
         selectedTagList.push(tag);
      }
      this.props.setWorkspaceFilterListFunction(selectedTagList);
   }

   toggleShowUntagged(){
      this.setState({showUntagged: !this.state.showUntagged});
   }

   render() {
      let isCreateConjecture = (window.location.pathname === '/conjectureCreation')
      let deck = this.props.deckList[0] || {cards: []};
      let tags = this.props.tagList.map((tag) => {
         return(
            <button
               key={tag}
               className={'btn ' + (this.props.tagFilterList.indexOf(tag) > -1 ? 'btn-dark': 'btn-outline-secondary')}
               onClick={() => this.onTagClicked(tag)}
            >
               {tag}
            </button>
         )
      });

      let filteredCardList = Object.values(deck.cards).filter((card) => {
         if(card.workspaceTags.length === 0)
            return this.state.showUntagged;

         for(let tagFilter of this.props.tagFilterList){
            if(card.workspaceTags.indexOf(tagFilter) > -1)
               return true;
         }
         return false;
      });

      return (
         <div>
            <div className='workspace-tag-container'>
               <h6>Viewing &micro;Pubs with the following tags. Click to toggle.</h6>
               {tags}
            </div>
            <div>
               <input type='checkbox' checked={this.state.showUntagged} onChange={() => this.toggleShowUntagged()} /> <label>Show &micro;Pubs without any tags</label>
            </div>
            <ListPane
               header={String.fromCharCode(181) + 'Pubs In Favorites'}
               cards={filteredCardList}
               linkFunction={(card) => this.props.cardLinkFunction(card)}
               showLinkBtn={isCreateConjecture}
               showFavoriteBtn={false}
               isExpanded={this.state.isExpanded}
               onHeaderClicked={() => this.setState({ isExpanded: !this.state.isExpanded })}
            />
         </div>
      );
   }
}



class AllTab extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         sponsorExpanded: true,
         toReviewIsExpanded: true,
         sharedIsExpanded: true,
         inReviewIsExpanded: true,
         publishedIsExpanded: true,
      }
   }

   render() {
      let isCreateConjecture = window.location.pathname === '/conjectureCreation' || this.props.isCreatingConjecture;
      return (
         <div>
            {!isCreateConjecture &&
            <div>
               {window.globals.isSponsor && (
                  <ListPane
                     header={'Your ' + String.fromCharCode(181) + 'Pubs' + String.fromCharCode(8482) + ' Awaiting Review'}
                     cards={this.props.unapprovedCards}
                     linkFunction={(card) => this.props.cardLinkFunction(card)}
                     showLinkBtn={false}
                     showReviewButton={true}
                     disableCardLink={true}
                     showAdditionalFunctionsButton={false}
                     isExpanded={this.state.sponsorExpanded}
                     onHeaderClicked={() => this.setState({ sponsorExpanded: !this.state.sponsorExpanded })}
                  />
               )}
               <ListPane
                  header={`${window.globals.isSponsor ? 'Other ' : ''}µPubs${String.fromCharCode(8482)} To Review`}
                  cards={this.props.cardsToReview}
                  linkFunction={(card) => this.props.cardLinkFunction(card)}
                  showLinkBtn={false}
                  showReviewButton={true}
                  disableCardLink={true}
                  showAdditionalFunctionsButton={false}
                  isExpanded={this.state.toReviewIsExpanded}
                  onHeaderClicked={() => this.setState({ toReviewIsExpanded: !this.state.toReviewIsExpanded })}
               />
               <ListPane
                  header={'Conjecture Shared With You'}
                  cards={this.props.conjectureGameCards}
                  linkFunction={(card) => this.props.cardLinkFunction(card)}
                  showLinkBtn={false}
                  showFavoriteBtn={true}
                  titleCharacterLimit={50}
                  showAdditionalFunctionsButton={true}
                  isExpanded={this.state.sharedIsExpanded}
                  onHeaderClicked={() => this.setState({ sharedIsExpanded: !this.state.sharedIsExpanded })}
               />
               {!window.globals.isSponsor && (
                  <ListPane
                     header={'Your ' + String.fromCharCode(181) + 'Pubs' + String.fromCharCode(8482) + ' Awaiting Review'}
                     cards={this.props.unapprovedCards}
                     linkFunction={(card) => this.props.cardLinkFunction(card)}
                     showLinkBtn={false}
                     showFavoriteBtn={false}
                     isExpanded={this.state.inReviewIsExpanded}
                     onHeaderClicked={() => this.setState({ inReviewIsExpanded: !this.state.inReviewIsExpanded })}
                  />
               )}
            </div>
            }
            <ListPane
               header={'Published ' + String.fromCharCode(181) + 'Pubs' + String.fromCharCode(8482)}
               cards={this.props.filteredCardList}
               linkFunction={(card) => this.props.cardLinkFunction(card)}
               showLinkBtn={isCreateConjecture}
               showFavoriteBtn={true}
               portfolios={this.props.portfolios}
               incubators={this.props.incubators}
               showAdditionalFunctionsButton={true}
               isExpanded={this.state.publishedIsExpanded}
               onHeaderClicked={() => this.setState({publishedIsExpanded: !this.state.publishedIsExpanded})}
            />
         </div>
      );
   }
}

class ListPane extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      if (!this.props.cards || this.props.cards.length === 0) {
         return <div />;
      }

      let cardRows = null;
      if(this.props.isExpanded) {
         let cards = this.props.cards.slice();
         cardRows = cards.map((card) => {
            if (card.cardType === SharedConstants.CardType.Evidence && this.props.showLinkBtn) {
               return <MPubCardLink key={shortid.generate()} card={card} initialTab={'mania'} />
            } else if (card.CardType === SharedConstants.Evidence || card.cardType === SharedConstants.Reasoning) {
               return <MPubCardSimple key={shortid.generate()} card={card} />
            }
         });
      }

      return (
         <div className='list-pane'>
            <div className='list-pane-header'>
               {this.props.header}
               <FontAwesomeIcon
                  icon={['far', (this.props.isExpanded ? 'chevron-up' : 'chevron-down')]}
                  size={'1x'}
                  style={{paddingTop: '4px', marginLeft: '0.5em', cursor: 'pointer'}}
                  onClick={() => this.props.onHeaderClicked()}
               />
            </div>
            {cardRows}
         </div>
      );
   }
}
